import axios from "axios";
import { ApiUtils } from "./ApiUtils";

export class PdfApi {
  private static readonly _baseUrl = ApiUtils.getBasePdfApiUrl();

  public static getStfPdf(request: any): Promise<any> {
    return axios.post(`${this._baseUrl}/quote/stf/pdf`, request, {
      responseType: "blob",
    });
  }

  public static getRentalPdf(request: any): Promise<any> {
    return axios.post(`${this._baseUrl}/quote/rental/pdf`, request, {
      responseType: "blob",
    });
  }
}
